import React, { useEffect } from 'react';
import Datadog from '../../../tools/Datadog';

/**
 * Higher Order Component that wraps a component to send a custom timing
 * to DataDog when the component is first mounted.
 * @example withCustomTiming(PERFORMANCE_MEASURE_NAMES.DSR_ROOMS_RENDERING_STARTED)(RoomsPage);
 */
const withCustomTiming =
  (ComponentDefinition: React.ComponentType, performanceMeasure: string) =>
  (props: any) => {
    useEffect(() => {
      Datadog.sendCustomTiming(performanceMeasure);
    }, []);

    return <ComponentDefinition {...props} />;
  };

export default withCustomTiming;
